/**
 * In some cases it comes handy to have locally the Icons that are being used
 * since its easier (by Icon component in this project) to manage their
 * attributes (path, circle, etc)
 */
enum Icons {
	// chart = '/icons/svg/chart-2.svg',
	addCircle = '/icons/svg/add-circle.svg',
	addEmptyState = '/icons/svg/add-image-empty-state.svg',
	alphabeticalOrder = '/icons/svg/alphabetical-order.svg',
	appleLogo = '/icons/svg/apple-logo.svg',
	appleMusic = '/icons/svg/apple-music.svg',
	arrowBounce = '/icons/svg/arrow-bounce-filled.svg',
	arrowDown = '/icons/svg/arrow-down.svg',
	arrowDownRight = '/icons/svg/arrow-down-right.svg',
	arrowLeft = '/icons/svg/arrowLeft.svg',
	arrowOutlineLeft = '/icons/svg/arrow-outline-left.svg',
	arrowOutlineRight = '/icons/svg/arrow-outline-right.svg',
	arrowRight = '/icons/svg/arrow-right.svg',
	arrowRight2 = '/icons/svg/arrow-right-2.svg',
	arrowRight3 = '/icons/svg/arrow-right-3.svg',
	arrowShare = '/icons/svg/arrow-share.svg',
	arrowUp = '/icons/svg/arrow-up.svg',
	arrowUpRight = '/icons/svg/arrow-up-right.svg',
	at = '/icons/svg/at.svg',
	avatar = '/icons/svg/avatar.svg',
	avatarFacebookSponsored = '/icons/svg/avatar-facebook-sponsored.svg',
	bank = '/icons/svg/bank.svg',
	barChart = '/icons/svg/barchart.svg',
	bigGreenCheck = '/icons/svg/big-green-check.svg',
	boardChart = '/icons/svg/board-chart.svg',
	book = '/icons/svg/book.svg',
	briefcase = '/icons/svg/briefcase.svg',
	briefcaseEmptyState = '/icons/svg/briefcase-empty-state.svg',
	broom = '/icons/svg/broom.svg',
	buildingApartment = '/icons/svg/building-apartment.svg',
	buildingsPurple = '/icons/svg/buildings-purple.svg',
	calendar = '/icons/svg/calendar.svg',
	calendar2 = '/icons/svg/calendar2.svg',
	calendar3 = '/icons/svg/calendar-3.svg',
	calendarCircle = '/icons/svg/calendar-circle.svg',
	calendarEight = '/icons/svg/calendarEight.svg',
	calendarEmpty = '/icons/svg/empty-calendar.svg',
	calendarPointerCenter = '/icons/svg/calendarPointCenter.svg',
	calendarPointerLeft = '/icons/svg/calendarPointLeft.svg',
	calendarWithBg = '/icons/svg/calendar-with-background.svg',
	call = '/icons/svg/call.svg',
	caretDown = '/icons/svg/caret-down.svg',
	caretUpDown = '/icons/svg/caret-up-down.svg',
	category = '/icons/svg/category.svg',
	char3 = '/icons/svg/chart-3.svg',
	chart = '/img/dashboard/chart-2.png',
	chart2 = '/icons/svg/chart2.svg',
	chartEmptyState = '/icons/svg/chart-empty-state.svg',
	chartPink = '/icons/svg/chart-pink.svg',
	chartUpEmptyState = '/icons/svg/chart-up-empty-state.svg',
	check = '/icons/svg/check.svg',
	checkCircle = '/icons/svg/checkCircle.svg',
	checkCircleEmptyState = '/icons/svg/check-circle-empty-state.svg',
	checkCircleGreen = '/icons/svg/check-circle.svg',
	checkEmptyState = '/icons/svg/check-empty-state.svg',
	checkGreen = '/icons/svg/checkGreen.svg',
	checkSquareOffset = '/icons/svg/check-square-offset.svg',
	checkWhite = '/icons/svg/check-white.svg',
	clear = '/icons/svg/clear.svg',
	clientAcquisition = '/icons/svg/client-acquisition-empty-state.svg',
	clipboard = '/icons/svg/clipboard.svg',
	clipboardClose = '/icons/svg/clipboard-close.svg',
	clock = '/icons/svg/clock.svg',
	close = '/icons/svg/close.svg',
	closeCircle = '/icons/svg/close-circle-black.svg',
	closeCircleRed = '/icons/svg/close-circle.svg',
	closeRed = '/icons/svg/close-red.svg',
	coin = '/icons/svg/coin.svg',
	coinbase = '/icons/svg/coinbase.svg',
	confirmComplete = '/icons/svg/confirm-complete.svg',
	copy = '/icons/svg/copy.svg',
	copyAlt = '/icons/svg/copy-alt.svg',
	crownCross = '/icons/svg/crown-cross.svg',
	currency = '/icons/svg/currency.svg',
	currencyBlack = '/icons/svg/currency-black.svg',
	currencyCircle = '/icons/svg/currency-circle.svg',
	cursor = '/icons/svg/cursor.svg',
	cursorClick = '/icons/svg/cursor-click.svg',
	cut = '/icons/svg/cut.svg',
	cylinderStackBlue = '/icons/svg/cylinder-stack-blue.svg',
	danger = '/icons/svg/danger.svg',
	dashboard = '/icons/svg/dashboard.svg',
	dashboardImage = '/img/landing/home/hero/dashboard-img.png',
	devicesEmptyState = '/icons/svg/devices-empty-state.svg',
	document = '/icons/svg/document.svg',
	documentDownload = '/icons/svg/document-download.svg',
	documentDownloadBlack = '/icons/svg/document-download-black.svg',
	documentDownloadBlue = '/icons/svg/document-download-blue.svg',
	documentDownloadGray = '/icons/svg/document-download-gray.svg',
	documentDownloadThin = '/icons/svg/document-download-thin.svg',
	documentFile = '/icons/svg/document-file.svg',
	documentGreen = '/icons/svg/document-green.svg',
	documentPrevious = '/icons/svg/document-previous.svg',
	documentsEmptyState = '/icons/svg/documents-empty-state.svg',
	documentsEmptyState2 = '/icons/svg/document-empty-state-2.svg',
	documentText = '/icons/svg/document-text.svg',
	documentUpload = '/icons/svg/document-upload.svg',
	documentUploadThin = '/icons/svg/document-upload-thin.svg',
	dotsMenuVertical = '/icons/svg/dots-menu-vertical.svg',
	download = '/icons/svg/download.svg',
	edit = '/icons/svg/edit.svg',
	editEmptyState = '/icons/svg/edit-empty-state.svg',
	editSquare = '/icons/svg/edit-square.svg',
	editTwo = '/icons/svg/edit-2.svg',
	ellipseHeroBlue = '/img/landing/svg/hero/ellipse-blue-top.svg',
	ellipseHeroPurpleLeft = '/img/landing/svg/hero/ellipse-purple-left.svg',
	ellipseHeroPurpleRight = '/img/landing/svg/hero/ellipse-purple-right.svg',
	emptyClipNote = '/icons/svg/empty-clip-note.svg',
	emptySpeaker = '/icons/svg/empty-speaker.svg',
	emptyStateBox = '/icons/svg/empty-state-box.svg',
	emptyWallet = '/icons/svg/empty-wallet.svg',
	circleGreenExclamation = '/icons/svg/circle-green-exclamation.svg',
	findCase = '/icons/svg/find-case.svg',
	envelope = '/icons/svg/envelope.svg',
	envelope2 = '/icons/svg/envelope2.svg',
	exclamationCircle = '/icons/svg/exclamation-circle.svg',
	exclamationEmptyState = '/icons/svg/exclamation-empty-state.svg',
	exclamationEmptyState2 = '/icons/svg/exclamation-empty-state-2.svg',
	expand = '/icons/svg/expand.svg',
	export = '/icons/svg/export.svg',
	externalLink = '/icons/svg/external-link.svg',
	eye = '/icons/svg/eye.svg',
	eye2 = '/icons/svg/eye2.svg',
	eyeSlash = '/icons/svg/eye-slash.svg',
	facebook = '/icons/svg/facebook.svg',
	facebook2 = '/icons/svg/facebook-2.svg',
	facebookComment = '/icons/svg/facebook-comment.svg',
	facebookLike = '/icons/svg/facebook-like.svg',
	facebookLikeGroup = '/icons/svg/facebook-like-group.svg',
	facebookLogo = '/icons/svg/facebookLogo.svg',
	facebookLove = '/icons/svg/facebook-love.svg',
	facebookShare = '/icons/svg/facebook-share.svg',
	file = '/icons/svg/file.svg',
	fileAlt = '/icons/svg/file-alt.svg',
	fileAltWhite = '/icons/svg/file-alt-white.svg',
	fileCheck = '/icons/svg/file-check.svg',
	files = '/icons/svg/files.svg',
	filesEmptyState = '/icons/svg/files-empty-state.svg',
	fileTime = '/icons/svg/file-time.svg',
	filter = '/icons/svg/filter.svg',
	filterEmptyState = '/icons/svg/filter-empty-state.svg',
	filterEmptyStateBgGray = '/icons/svg/filter-empty-state-bg-gray.svg',
	filterSearch = '/icons/svg/filter-search.svg',
	firstAid = '/icons/svg/first-aid.svg',
	flag = '/icons/svg/flag.svg',
	flagFilled = '/icons/svg/flag-filled.svg',
	flipRight = '/icons/svg/flip-right.svg',
	flipVertical = '/icons/svg/flip-vertical.svg',
	fluentArrow = '/icons/svg/fluent-arrow.svg',
	folderAdd = '/icons/svg/folder-add.svg',
	folderCloud = '/icons/svg/folder-cloud.svg',
	folderCloudGreen = '/icons/svg/folder-cloud-green.svg',
	folderCloudHold = '/icons/svg/folder-cloud-hold.svg',
	folderOpen = '/icons/svg/folder-open.svg',
	folderOpenBlue = '/icons/svg/folder-open-blue.svg',
	folderTwo = '/icons/svg/folder-2.svg',
	funnel = '/icons/svg/funnel.svg',
	funnelEmpty = '/icons/svg/funnel-empty.svg',
	gallery = '/icons/svg/gallery.svg',
	galleryAdd = '/icons/svg/gallery-add.svg',
	galleryEdit = '/icons/svg/gallery-edit.svg',
	galleryEdit2 = '/icons/svg/gallery-edit2.svg',
	gasPump = '/icons/svg/gas-pump.svg',
	gear = '/icons/svg/gear.svg',
	gmail = '/icons/svg/gmail.svg',
	gmail2 = '/icons/svg/mail-gmail.svg',
	google = '/icons/svg/google.svg',
	google2 = '/icons/svg/google-2.svg',
	googleAds = '/icons/svg/google-ads.svg',
	grains = '/icons/svg/grains.svg',
	graph = '/icons/svg/graph.svg',
	grayCalendar = '/icons/svg/gray-calendar.svg',
	greenDot = '/icons/svg/green-dot.svg',
	greenIconBackground = '/icons/svg/green-icon-background.svg',
	greenLines = '/icons/svg/green-lines.svg',
	greyDot = '/icons/svg/grey-dot.svg',
	handArrowDown = '/icons/svg/hand-arrow-down.svg',
	hat = '/icons/svg/hat.svg',
	hatAvatar = '/icons/svg/hat-avatar.svg',
	hatGray = '/icons/svg/hat-gray.svg',
	headset = '/icons/svg/headset.svg',
	hero = '/img/landing/svg/hero/hero-section.svg',
	heroLarge = '/img/landing/svg/hero/hero-section-large.svg',
	hexagonPerson = '/icons/svg/hexagon-person.svg',
	home = '/icons/svg/home.svg',
	identificationCard = '/icons/svg/identification-card.svg',
	image = '/icons/svg/img.svg',
	imageCards = '/icons/svg/image-cards.svg',
	imageCardsAlt = '/icons/svg/image-cards-alt.svg',
	imageEmptyState = '/icons/svg/image-empty-state.svg',
	info = '/img/dashboard/info.png',
	infoCircle = '/icons/svg/info-circle.svg',
	infoEmptyState = '/icons/svg/info-empty-state.svg',
	infoFilled = '/icons/svg/info-filled.svg',
	instagram = '/icons/svg/instagram.svg',
	instagramBookMark = '/icons/svg/instagram-bookmark.svg',
	instagramComment = '/icons/svg/instagram-comment.svg',
	instagramLogo = '/icons/svg/instagramLogo.svg',
	invisible = '/icons/svg/invisible.svg',
	lawyerAvatar = '/icons/svg/lawyer-avatar.svg',
	letterEmptyState = '/icons/svg/letter-empty-state.svg',
	lightning = '/icons/svg/lightning.svg',
	like = '/icons/svg/like.svg',
	likeGreen = '/icons/svg/like-green.svg',
	lineChart = '/icons/svg/line-chart.svg',
	linkedin = '/icons/svg/linkedin.svg',
	list = '/icons/svg/list.svg',
	listBullets = '/icons/svg/list-bullets.svg',
	listNumbers = '/icons/svg/list-numbers.svg',
	location = '/icons/svg/location.svg',
	locationEmptyState = '/icons/svg/location-empty-state.svg',
	lock = '/icons/svg/lock.svg',
	lockWhite = '/icons/svg/lock-white.svg',
	logoLowey = '/icons/svg/logo-lowey.svg',
	logout = '/icons/svg/logout.svg',
	loweyDannenBerg = '/icons/svg/lowey-dannenberg-logo-footer 1.svg',
	loweyDannenBergDiamon = '/icons/svg/Lowey-dannenberg-diamond.svg',
	magnifyingGlass = '/icons/svg/magnifying-glass.svg',
	mailDot = '/icons/svg/mail-dot.svg',
	mainCheck = '/icons/svg/main-check.svg',
	megaphone = '/icons/svg/megaphone.svg',
	megaphoneEmptyState = '/icons/svg/megaphone-empty-state.svg',
	message = '/icons/svg/message.svg',
	messageQuestion = '/icons/svg/message-question.svg',
	messageQuestionEmpty = '/icons/svg/message-question-empty.svg',
	messageQuestionInterrogation = '/icons/svg/message-question-interrogation.svg',
	messages = '/icons/svg/messages.svg',
	messagesEmptyState = '/icons/svg/messages-empty-state.svg',
	metamask = '/icons/svg/metamask.svg',
	metricsEmptyState = '/icons/svg/metrics-empty-state.svg',
	metricsTableEmptyState = '/icons/svg/metrics-table-empty-state.svg',
	microsoft = '/icons/svg/microsoft.svg',
	minus = '/icons/svg/minus.svg',
	mobileCircle = '/icons/svg/mobile-circle.svg',
	moneyEmptyState = '/icons/svg/money-empty-state.svg',
	moneyReceive = '/icons/svg/money-receive.svg',
	moneyReceiveGreen = '/icons/svg/money-receive-green.svg',
	moneySend = '/icons/svg/money-send.svg',
	more = '/icons/svg/more.svg',
	mouseEmptyState = '/icons/svg/mouse-empty-state.svg',
	netflix = '/icons/svg/netflix.svg',
	nodata = '/icons/svg/no_data.svg',
	note = '/icons/svg/note.svg',
	note2 = '/icons/svg/note2.svg',
	noteMagnifyingGlass = '/icons/svg/note-magnifying-glass.svg',
	notification = '/icons/svg/notification.svg',
	outlineFacebook = '/icons/svg/outline-rss/FacebookLogo.svg',
	outlineInstagram = '/icons/svg/outline-rss/InstagramLogo.svg',
	outlineXLogo = '/icons/svg/outline-rss/XLogo.svg',
	package = '/icons/svg/package.svg',
	page = '/icons/svg/page.svg',
	pagesEmptyState = '/icons/svg/pages-empty-state.svg',
	path = '/icons/svg/path.svg',
	pdf = '/icons/svg/pdf.svg',
	pdfFile = '/img/common/pdf-file.png',
	people = '/icons/svg/people.svg',
	peopleEmptyState = '/icons/svg/people-empty-state.svg',
	person = '/icons/svg/person.svg',
	personalCard = '/icons/svg/personal-card.svg',
	phoneVerified = '/icons/svg/phone-verified.svg',
	pin = '/icons/svg/pin.svg',
	pinFulled = '/icons/svg/pin-fulled.svg',
	pinFulledGreen = '/icons/svg/pin-filled-green.svg',
	play = '/icons/svg/play.svg',
	plus = '/icons/svg/plus.svg',
	plus2 = '/icons/svg/plus-2.svg', //can change the color of this one
	presentationEmptyState = '/icons/svg/presentation-empty-state.svg',
	profile = '/icons/svg/profile.svg',
	profileCheck = '/icons/svg/profile-check.svg',
	profileDelete = '/icons/svg/profile-delete.svg',
	profileEdit = '/icons/svg/profile-edit.svg',
	profileEmptyState = '/icons/svg/profile-empty-state.svg',
	profileGreen = '/icons/svg/profile-green.svg',
	profileLocation = '/icons/svg/profile-location.svg',
	profilePurple = '/icons/svg/profile-purple.svg',
	profileThin = '/icons/svg/profile-thin.svg',
	profileTick = '/icons/svg/profile-tick.svg',
	profileUsers = '/icons/svg/profile-2user.svg',
	profileUsersEmptyState = '/icons/svg/profile-users-empty-state.svg',
	question = '/icons/svg/question.svg',
	questionGreen = '/icons/svg/question-green.svg',
	quoteDown = '/icons/svg/quote-down.svg',
	rafiki = '/icons/svg/rafiki.svg',
	receiptSearch = '/icons/svg/receipt-search.svg',
	receiptSearchAlt = '/icons/svg/receipt-search-alt.svg',
	redDanger = '/icons/svg/red-danger.svg',
	refresh = '/icons/svg/refresh.svg',
	refresh2 = '/icons/svg/refresh-2.svg',
	refreshAlt = '/icons/svg/refresh-alt.svg',
	refreshRight = '/icons/svg/refresh-right.svg',
	retentionEmptyState = '/icons/svg/retention-empty-state.svg',
	rotateLeft = '/icons/svg/rotate-left.svg',
	rotateRight = '/icons/svg/rotate-right.svg',
	screencast = '/icons/svg/screencast.svg',
	sealCheck = '/icons/svg/seal-check.svg',
	search = '/icons/svg/search-normal.svg',
	searchCaseEmptyState = '/icons/svg/search-case-empty-state.svg', // you can edit the color of this one
	searchZoomIn = '/icons/svg/search-zoom-in.svg',
	searchZoomOut = '/icons/svg/search-zoom-out.svg',
	security = '/icons/svg/security.svg',
	segmentationEmptyState = '/icons/svg/segmentation-empty-state.svg',
	send = '/icons/svg/send.svg',
	sendEmail = '/icons/svg/send-email.svg',
	sendPurple = '/icons/svg/send-purple.svg',
	sendTwo = '/icons/svg/send-2.svg',
	setting4 = '/icons/svg/setting-4.svg',
	setting5 = '/icons/svg/setting-5.svg',
	settings = '/icons/svg/settings.svg',
	shieldCheckered = '/icons/svg/shield-checkered.svg',
	shieldSecurity = '/icons/svg/shield-security.svg',
	shop = '/icons/svg/shop.svg',
	simpleArrowRight = '/icons/svg/simple-arrow-right.svg',
	smiley = '/icons/svg/smiley.svg',
	smiley2 = '/icons/svg/smiley2.svg',
	smileyGreen = '/icons/svg/smiley-green.svg',
	sms = '/icons/svg/sms.svg',
	smsEmptyState = '/icons/svg/sms-empty-state.svg',
	smsLinear = '/icons/svg/sms-linear.svg',
	smsNotification = '/icons/svg/sms-notification.svg',
	smsTracking = '/icons/svg/sms-tracking.svg',
	starShield = '/icons/svg/star-shield.svg',
	stethoscope = '/icons/svg/stethoscope.svg',
	suitcase = '/icons/svg/suitcase.svg',
	suitcaseBg = '/icons/svg/suit-case-bg.svg',
	suitcaseThick = '/icons/svg/suitcase-thick.svg',
	sun = '/icons/svg/sun.svg',
	table = '/icons/svg/table.svg',
	tablerIconGavel = '/icons/svg/tabler-icon-gavel.svg',
	tag = '/icons/svg/tag-2.svg',
	tagIcon = '/icons/svg/tag-icon.svg',
	target = '/icons/svg/target.svg',
	textAlignCenter = '/icons/svg/textalign-center.svg',
	thermometer = '/icons/svg/thermometer.svg',
	tickCircle = '/icons/svg/tick-circle.svg',
	tickSquare = '/icons/svg/tick-square.svg',
	timer = '/icons/svg/timer.svg',
	tower = '/icons/svg/tower.svg',
	trash = '/icons/svg/trash.svg',
	trashPNG = '/img/common/trash.png',
	twoCoins = '/icons/svg/two-coins.svg',
	unread = '/icons/svg/unread.svg',
	uploadCloud = '/icons/svg/upload-cloud.svg',
	userAdd = '/icons/svg/user-add.svg',
	userEdit = '/icons/svg/user-edit.svg',
	userOctagon = '/icons/svg/user-octagon.svg',
	userOne = '/icons/svg/user-one.svg',
	userSearch = '/icons/svg/user-search.svg',
	userSearch2 = '/icons/svg/user-search-2.svg', // you can edit the color of this one
	usersEmpty = '/icons/svg/empty-flagged-state.svg',
	usersEmptyState = '/icons/svg/users-empty-state.svg',
	usersGroupEmptyState = '/icons/svg/users-group-empty-state.svg',
	userSquare = '/icons/svg/user-in-square.svg',
	userThree = '/icons/svg/user-three.svg',
	userTwo = '/icons/svg/user-two.svg',
	verifyingIdentity = '/icons/svg/verifying-identity.svg',
	visible = '/icons/svg/visible.svg',
	wand = '/icons/svg/icon-wand.svg',
	warningShield = '/icons/svg/warning-shield.svg',
	watchEmptyState = '/icons/svg/watch-empty-state.svg',
	whatsApp = '/icons/svg/whatsapp.svg',
	whatsappLogo = '/icons/svg/whatsapp-logo.svg',
	worldEmptyState = '/icons/svg/world-empty-state.svg',
	worldFacebook = '/icons/svg/world-facebook.svg',
	x = '/icons/svg/x.svg',
	xLogo = '/icons/svg/xLogo.svg',
	xlsx = '/icons/svg/xlsx.svg',
	yellowDanger = '/icons/svg/yellow-danger.svg',
	yellowDot = '/icons/svg/yellow-dot.svg',
	whatHappensGroup = '/icons/svg/what-happens-group.svg',
	bubblesTour = '/icons/svg/bubbles-tour.svg',
}

export default Icons;
